import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function Footer() {
  const [footerContent, setFooterContent] = useState({});

  useEffect(() => {
    // Henter kun innhold for 'global'-siden, som er der vi la footer-teksten
    axios.get(`${API_URL}/api/content/global`)
      .then(res => {
        const organized = res.data.reduce((acc, item) => ({ ...acc, [item.element_id]: item }), {});
        setFooterContent(organized);
      })
      .catch(err => console.error("Feil ved henting av footer-innhold:", err));
  }, []);

  return (
    <footer className="main-footer">
      <div className="container">
        <p>{footerContent.footer_linje_1?.value}</p>
        <p>{footerContent.footer_linje_2?.value}</p>
      </div>
    </footer>
  );
}

export default Footer;